module.exports = {"data":{"markdownRemark":{"html":"<p>Pandas are really sweet.</p>\n<p>Here's a video of a panda eating sweets.</p>\n<p><img src=\"/logo.png\" alt=\"logo\"></p>","frontmatter":{"title":"南京地震馆"}}},"pathContext":{"slug":"/solutions/南京地震馆/"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/solutions-南京地震馆.json
// module id = 499
// module chunks = 102433428468292